import React, { useState } from "react";
import { SITE_CONFIG } from "../config/siteConfig";

// ══════════════════════════════════════════════════════════════
// ⚠️  À CHANGER : connectez le formulaire à votre backend
//
// Option 1 — Netlify Forms :
//   Ajoutez data-netlify="true" et name="contact" sur le <form>
//
// Option 2 — EmailJS ou autre :
//   Remplacez le handleSubmit par votre logique d'envoi
// ══════════════════════════════════════════════════════════════

const Contact: React.FC = () => {
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    event: "",
    message: "",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // ⚠️ Remplacez ici par votre logique d'envoi (fetch, emailjs, etc.)
    console.log("Form data:", formData);
    setSubmitted(true);
  };

  const inputClass =
    "w-full bg-transparent border border-white/10 rounded-sm px-4 py-3.5 text-white text-sm placeholder-zinc-600 focus:outline-none focus:border-amber-700/50 transition-colors duration-300";

  return (
    <section id="contact" className="py-24 bg-black">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16">
          {/* Infos */}
          <div>
            <p className="text-amber-600/60 tracking-[0.3em] uppercase text-xs mb-4">
              Contact
            </p>
            <h2
              className="text-4xl md:text-5xl mb-8 font-display"
              style={{ color: "#BB9D63", lineHeight: 1.2 }}
            >
              Parlons de votre
              <br />
              événement
            </h2>

            <div className="space-y-6 mb-10">
              {[
                { icon: "✉", label: "Email", value: SITE_CONFIG.email },
                { icon: "☎", label: "Téléphone", value: SITE_CONFIG.phone },
                { icon: "◷", label: "Disponibilité", value: SITE_CONFIG.availability },
              ].map((item) => (
                <div key={item.label} className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-amber-600 text-sm">{item.icon}</span>
                  </div>
                  <div>
                    <p className="text-zinc-500 text-xs tracking-wider uppercase mb-1">
                      {item.label}
                    </p>
                    <p className="text-white text-sm">{item.value}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Formulaire */}
          <div>
            {submitted ? (
              <div className="h-full flex items-center justify-center p-12 border border-amber-800/20 rounded-sm bg-amber-900/5">
                <div className="text-center">
                  <div className="text-4xl mb-4">✓</div>
                  <h3
                    className="text-2xl mb-3 font-display"
                    style={{ color: "#BB9D63" }}
                  >
                    Message envoyé !
                  </h3>
                  <p className="text-zinc-400 text-sm max-w-sm">
                    Merci de nous avoir contactés. Nous vous répondrons dans
                    les plus brefs délais.
                  </p>
                </div>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-5">
                <div className="grid sm:grid-cols-2 gap-5">
                  <input
                    type="text"
                    name="name"
                    placeholder="Votre nom"
                    required
                    value={formData.name}
                    onChange={handleChange}
                    className={inputClass}
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Votre email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className={inputClass}
                  />
                </div>
                <div className="grid sm:grid-cols-2 gap-5">
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Téléphone"
                    value={formData.phone}
                    onChange={handleChange}
                    className={inputClass}
                  />
                  <select
                    name="event"
                    value={formData.event}
                    onChange={handleChange}
                    className={inputClass}
                    style={{ color: formData.event ? "#fff" : "#52525b" }}
                  >
                    <option value="">Type d'événement</option>
                    <option value="mariage">Mariage</option>
                    <option value="anniversaire">Anniversaire</option>
                    <option value="entreprise">Événement d'entreprise</option>
                    <option value="gala">Gala / Soirée</option>
                    <option value="autre">Autre</option>
                  </select>
                </div>
                <textarea
                  name="message"
                  placeholder="Décrivez votre événement..."
                  rows={5}
                  required
                  value={formData.message}
                  onChange={handleChange}
                  className={inputClass + " resize-none"}
                />
                <button
                  type="submit"
                  className="w-full py-4 bg-gradient-to-r from-amber-700 to-amber-600 text-black font-semibold tracking-wider uppercase text-sm hover:from-amber-600 hover:to-amber-500 transition-all duration-300 rounded-sm"
                >
                  Envoyer ma demande
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
